import { useParams } from "react-router";
import { ProductForm } from "./ProductForm";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useProductMetadataContext } from "src/context/Product/Metadata/useProductMetadata";
import { Forbiddenpage } from "src/components/PageState/ForbiddenPage";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { ProductFormV2 } from "src/pages/Product/v2/ProductFormV2/ProductFormV2";
import { ProductScoresProtection } from "src/pages/Product/ProductScoresProtection";

export const UpdateQuestionnaire = () => {
    const { startingPageId } = useParams();
    const { company } = useCompanyMetadata();
    const { product, productReference, scores } = useProductMetadataContext();
    const isProductUxV2 = useIsProductUxV2();

    if (product?.canModify === false) {
        return <Forbiddenpage />;
    }

    const commonProps = {
        companyIds: {
            id: company.id,
            "@id": company["@id"],
            name: company.name,
        },
        productReference,
        existingProduct: product,
        scores,
        startingPageId: startingPageId ?? "0",
    };

    if (isProductUxV2) {
        return (
            <ProductScoresProtection>
                <ProductFormV2 {...commonProps} />
            </ProductScoresProtection>
        );
    }

    return <ProductForm {...commonProps} />;
};
